import type { ReactNode } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import { ScrollToTop } from './ScrollToTop'
import { CookieConsent } from '@/components/ui/CookieConsent'

interface Props {
  children: ReactNode
}

export function Layout({ children }: Props) {
  return (
    <div className="flex min-h-screen flex-col bg-surface text-ink">
      <Header />
      {/* Reserve the fixed header's height (see Header): 4rem, 7.25rem on lg. */}
      <main id="main-content" tabIndex={-1} className="flex-1 pt-16 lg:pt-[7.25rem]">
        {children}
      </main>
      <Footer />
      <ScrollToTop />
      <CookieConsent />
    </div>
  )
}
